import {Component, Input, OnInit} from '@angular/core';
import {CplItem} from '../../../model/cpl-item.model';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {UserAssignment} from '../../../supervision-management/compliance-items/compliance-item/enums/user-assignment.enum';
import {CplCycle} from '../../../model/cpl-cycle.model';
import {FileAttachment} from '../../../model/file-attachment.model';
import {FileService} from '../../../services/file.service';
import { ComplianceItemHelpersService } from '../../../services/compliance-item-helpers/compliance-item-helpers.service';
import { A48HelpersService } from 'src/app/services/a48-helpers/a48-helpers.service';
import { CplA48Labels } from 'src/app/model/cpl-a48-labels.model';
import { FileDownloadHandler, PagedResponse, PortalSettings, SessionService } from '@edl-development/edl-common';
import { EdlItemPacketUserSummaryDTO } from 'src/app/model/item-packet/edl-item-packet-user-summary-dto.model';
import { TimeTrackingTypes } from 'src/app/model/enum/cpl-time-tracking-type.enum';
import { TimeTrackingHelperService } from 'src/app/time-tracking/services/time-tracking-helper/time-tracking-helper.service';
@Component({
    selector: 'compliance-item-cycle-requirements',
    templateUrl: './compliance-item-cycle-requirements.component.html',
    styleUrls:   ['./compliance-item-cycle-requirements.component.scss']
})
export class ComplianceItemCycleRequirementsComponent implements OnInit {
    @Input() complianceItem: CplItem;
    @Input() userCycle: CplCycle;
    @Input() itemPackets: EdlItemPacketUserSummaryDTO[] = [];
    @Input() cycleHistory: PagedResponse;
    @Input() ActionRequired: boolean;

    portalSettings:PortalSettings;
    instructions: SafeHtml;

    A48Labels: CplA48Labels;
    UserAssignment = UserAssignment;
    TimeTrackingType = TimeTrackingTypes;

    filteredItemPackets: EdlItemPacketUserSummaryDTO[] = [];

    constructor(
        public a48HelpersService: A48HelpersService,
        public complianceItemHelpersService: ComplianceItemHelpersService,
        private timeTrackingHelperService: TimeTrackingHelperService,
        private sanitizer: DomSanitizer,
        private fileService: FileService,
        private sessionService: SessionService,
        private fileHandler: FileDownloadHandler
    ) {}

    ngOnInit() {
        this.portalSettings = this.sessionService.PortalSettings;
        this.instructions = this.sanitizer.bypassSecurityTrustHtml(this.complianceItem.Instructions);

        // Filters item packets so it only includes ones that are associate with both the user and compliance item
        const itemPacketsForItem = this.complianceItem.ItemPackets.map((itemPacket) => itemPacket.Id);
        this.filteredItemPackets = this.itemPackets.filter((itemPacket) => itemPacketsForItem.includes(itemPacket.Packet.Id));
  
        if(this.isAct48Enabled()){
            this.A48Labels = this.a48HelpersService.getAct48DetailsLabels(this.complianceItem.Act48Detail);
        }
    }

    get canViewItemPackets() {
        return this.filteredItemPackets && this.filteredItemPackets.length > 0;
    }

    daysRemaining(cycle: CplCycle) {
        return this.complianceItemHelpersService.GetDaysRemaining(cycle);
    }

    Negative(cycle: CplCycle) {
        return this.complianceItemHelpersService.Negative(cycle);
    }

    viewAttachement(attachment: FileAttachment) {
        this.fileService
            .getFileResponse(attachment.FileID)
            .subscribe((fileResponse : Blob) => {
                this.fileHandler.saveFile(fileResponse, attachment.FileName);
            });   
    }

    isAct48Enabled(){
        return this.portalSettings.Act48Enabled && this.complianceItem.Act48Detail != null && this.complianceItem.Act48Detail.Applicable;
    }

    isFlexEnabled(){
        return this.complianceItem?.FlexDetails?.Applicable;
    }

    getA48Hours(){
        return this.userCycle.A48Hours > 0 ? this.userCycle.A48Hours :  this.complianceItem.Act48Detail.Hours;
    }
    
    get getFlexHours(){
        return this.timeTrackingHelperService.getUserCycleDisplayHours(this.userCycle, this.complianceItem);
    }

    getActivityType(){
        return this.userCycle.A48Hours > 0 ? this.userCycle.A48ActivityType :  this.complianceItem.Act48Detail.ActivityType;
    }

    public getSubmissionStatus(){
        let status = "";
        if(this.userCycle.ParaStatus == 5){
            status += "Paraeducator hours approved. Act 48 Submission: " + this.userCycle.A48Status;
        } else {
            status =this.userCycle.A48Status;
        }
        return status;
    }

}